import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-question-spacer',
  templateUrl: './question-spacer.component.html',
  styleUrls: ['./question-spacer.component.css'],
})
export class QuestionSpacerComponent implements OnInit, OnChanges {
  @Input() questionSpacer: number;
  @Input() BottomPosition: boolean;

  constructor() {}

  ngOnInit() {
    this.applySpacerLogic();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.applySpacerLogic();
  }

  private applySpacerLogic(): void {
    if (this.BottomPosition) {
      this.questionSpacer = this.questionSpacer == undefined ? 35 : this.questionSpacer - 5;
    } else {
      this.questionSpacer = 5;
    }
  }
}
